import { Theme } from '@mui/material/styles'
import { createTheme } from '@mui/material/styles'

interface ModalConfig {
   theme: Theme
}

export const modalConfig: ModalConfig = {
   theme: createTheme(),
}

export function setModalTheme(theme: Theme) {
   modalConfig.theme = theme
}